export const destroy = (self) => {
  if (self._mouseDownHandler != null) {
    self._canvas_el?.removeEventListener("mousedown", self._mouseDownHandler);
    self._mouseDownHandler = null;
  }
  if (self._mouseMoveHandler != null) {
    self._window.removeEventListener("mousemove", self._mouseMoveHandler);
    self._mouseMoveHandler = null;
  }
  if (self._mouseUpHandler != null) {
    self._window.removeEventListener("mouseup", self._mouseUpHandler);
    self._mouseUpHandler = null;
  }
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  if (self._target_image_dummy_g_el != null) {
    self._target_image_el?.removeChild(self._target_image_dummy_g_el);
  }
  if (self._target_image_el != null) {
    self._target_image_inner_wrapper_g_el?.removeChild(self._target_image_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._dummy_g_el = null;
  self._layers_el = null;
  self._target_image_layer_el = null;
  self._cutting_line_layer_el = null;
  self._path_editor_layer_el = null;
  self._target_image_outer_wrapper_g_el = null;
  self._target_image_inner_wrapper_g_el = null;
  self._target_image_dummy_g_el = null;
  self._outer_cutting_line_clip_path_el = null;
  self._inner_cutting_line_clip_path_el = null;
  self._outer_cutting_line_display_path_el = null;
  self._path_editor_line_container_el = null;
  self._path_editor_point_container_el = null;
  self._view_port = null;
  self._view_box = null;
  self._stroke_sync = null;
  self._target_image_el = null;
  self._path_editor_list = [];
  self._path_editor_point_size_controller = null;
  self._processing_task = null;
  self._mouseDownHandler = null;
  self._mouseMoveHandler = null;
  self._mouseUpHandler = null;
  self._is_mouse_down = false;
  self._is_mouse_move = false;
  self._mouse_down_position = {
    x: 0,
    y: 0,
  };
  self._mouse_move_position = {
    x: 0,
    y: 0,
  };
};
